
import React from 'react';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { fadeIn } from '@/utils/animations';
import HeroSection from '@/components/offer/HeroSection';
import { 
  SiliconValleyStory, 
  BreakthroughStory, 
  TransitionStory, 
  NextStageStory 
} from '@/components/offer/StoryContentSection';
import OfferCtaSection from '@/components/offer/OfferCtaSection';
import ResultsGridSection from '@/components/offer/ResultsGridSection';
import LearningSection from '@/components/offer/LearningSection';
import MailboxSetupSection from '@/components/offer/MailboxSetupSection';
import OpenRatesSection from '@/components/offer/OpenRatesSection';
import TopPerformingCopiesSection from '@/components/offer/TopPerformingCopiesSection';
import TestimonialsSection from '@/components/offer/TestimonialsSection';
import ContactDataSection from '@/components/offer/ContactDataSection';
import ClientConversionSection from '@/components/offer/ClientConversionSection';

const OfferPage = () => {
  return (
    <motion.div 
      className="min-h-screen bg-white py-12"
      initial="initial"
      animate="animate"
      variants={fadeIn}
    >
      <div className="max-w-4xl mx-auto px-6">
        <motion.h1
          className="text-3xl md:text-5xl font-bold text-center text-red-600 mb-8"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          You're Waitlisted... But WAIT!
        </motion.h1>
        
        <HeroSection />
        <SiliconValleyStory />
        <BreakthroughStory />
        <TransitionStory />
        <NextStageStory />
        <OfferCtaSection />
        <ResultsGridSection />
        <TestimonialsSection />
        <LearningSection />
        <MailboxSetupSection />
        <OpenRatesSection />
        <TopPerformingCopiesSection />
        <ContactDataSection />
        <ClientConversionSection />

        <div className="text-center mt-12">
          <Link to="/">
            <Button 
              variant="outline" 
              className="border-gray-300 text-gray-700 hover:bg-gray-100"
            >
              Return to Home
            </Button>
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default OfferPage;
